var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard"},[_c('el-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('span',[_vm._v("欢迎使用奥特莱斯管理系统")])]),_c('div',{staticClass:"welcome-content"},[_c('p',[_vm._v("请从左侧菜单选择功能模块")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }